import { Quantity } from "../../../Components/Form/Quantity";
import { EVENTS } from "./Constants";
import { SELECTORS as CART_SELECTORS } from "../../Cart/Constants";
import { SELECTORS } from "../Configurator/Constants";

let quantities: Quantity[] = [...document.querySelectorAll<Quantity>(SELECTORS.QUANTITY)];
let current = 1;
const ctaButtons = document.querySelectorAll<HTMLElement>(CART_SELECTORS.ADD);

const changeHandler = (e: CustomEvent) => {
    const target = e.target as Quantity;
    ctaButtons.forEach((cta) => (cta.dataset.quantity = target.value));
    quantities.filter((q) => q !== e.target).forEach((q) => (q.value = target.value));
};

export const removeQuantityListeners = () => {
    if (quantities.length) {
        current = +quantities[0].value;
        quantities.forEach((quantity) => {
            quantity.removeEventListener(EVENTS.CHANGE, changeHandler);
        });
    }
};

export const initQuantityFields = () => {
    quantities = [...document.querySelectorAll<Quantity>(SELECTORS.QUANTITY)];
    if (quantities.length) {
        const min = quantities[0].min;
        const max = quantities[0].max;
        quantities.forEach((quantity) => {
            quantity.min = min;
            quantity.max = max;
            quantity.value = String(Math.min(current, +max));
            quantity.addEventListener(EVENTS.CHANGE, changeHandler);
        });
    }
};
if (quantities.length) {
    initQuantityFields();
}
